import React from 'react'

import apiObjectStyles from "./Table.module.css"

export default function ApiMethod({ children }) {

    return(       
        <div className={apiObjectStyles.container}>
            <table>
                <tbody>
                    {children}
                </tbody>
            </table>
        </div>
    )
}